"use client";

import { usePathname } from "next/navigation";
import Image from "next/image";
import { useEffect } from "react";
import styles from "./BottomNavItem.module.scss";
import { cn } from "@utils/utils";
import assetLoader from "@utils/internalImageLoder";
import { EventType, trackEventWithCommonProps } from "@utils/eventTracker";
import { useGlobalLoader } from "@hooks/useGlobalLoader";
import { getPageNameFromUrl } from "@utils/pageNameUtils";

interface BottomNavItemProps {
  href: string;
  inactiveIcon: string;
  activeIcon: string;
  label: string;
  exactMatch?: boolean;
  action_name: string;
  cityName?: any;
}

export default function BottomNavItem({
  href,
  inactiveIcon,
  activeIcon,
  label,
  exactMatch = true,
  action_name,
  cityName
}: BottomNavItemProps) {
  const pathname = usePathname();
  const { showLoader, hideLoader } = useGlobalLoader();

  useEffect(() => {
    hideLoader();
  }, [pathname, hideLoader]);

  const isActive = (label === 'New Car') 
                  ? (pathname === '/cars' || pathname === '/cars/' || pathname === '/collection' || pathname?.startsWith('/collection/'))
                  : (exactMatch ? pathname === href : pathname?.startsWith(href));
  
  const currentIcon = isActive ? activeIcon : inactiveIcon;

  const handleClick = async () => {
    if (href != pathname) {
      showLoader('Loading...');
      await trackEventWithCommonProps("action", EventType.TRACK_EVENT, {
        pageType: getPageNameFromUrl(pathname),
        additionalProps: {
          action_type: "tap_btn",
          action_name: action_name,
          section: "Bottom Navigation",
          city_name: cityName,
        },
      });
  
      setTimeout(() => {
        window.location.href = href;
      },1000)
    }
  };

  return (
    <>
      <div 
        className={cn(styles.navItem, isActive && styles.active)}
        onClick={handleClick}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            handleClick();
          }
        }}
      >
        <div className={styles.iconWrapper}>
          <Image
            src={`${assetLoader()}${currentIcon}`}
            alt={label}
            width={24}
            height={24}
            className={styles.icon}
            loading="lazy"
          />
        </div>
        <span className={styles.label}>{label}</span>
      </div>
    </>
  );
}
